export default __webpack_public_path__ + "static/Transcript_Form-7fda94fc798ccb49861afb8e853478ae.pdf";